import React from 'react'
import './Footer.css'
import reactLogo from './assets/logo_react.png'
import springLogo from './assets/logo_reactSpring.png'

const Footer = () =>
{
    const imgHeight = '35px';
    const bootstrapStyling = 'col btn';
       
    return (
        <div className='footer-container'>
            <div className='container'>
                <h3 style={{textAlign: 'center'}}>Website made with:</h3>
                <div className='footer-grid'>
                    <a href='https://react.dev/' className={bootstrapStyling}><img className='footer-centered-element' src={reactLogo} height={imgHeight} /><h4 className='footer-centered-element'>React</h4></a>
                    <a href='https://www.react-spring.dev/' className={bootstrapStyling}><img className='footer-centered-element' src={springLogo} height={imgHeight} /><h4 className='footer-centered-element'>react-spring</h4></a>
                    <a href='https://getbootstrap.com/' className={bootstrapStyling}><img className='footer-centered-element' src='/graphics/bootstrap_logo.png' height={imgHeight} /><h4 className='footer-centered-element'>Bootstrap</h4></a>
                    <a href='https://expressjs.com/' className={bootstrapStyling}><img className='footer-centered-element' src='https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png' height={imgHeight} /><h4 className='footer-centered-element'>Expressjs</h4></a>
                    <a href='https://www.mysql.com/' className={bootstrapStyling}><img className='footer-centered-element' src='https://upload.wikimedia.org/wikipedia/en/thumb/d/dd/MySQL_logo.svg/1280px-MySQL_logo.svg.png' height={imgHeight} /><h4 className='footer-centered-element'>MySQL</h4></a>
                    <a href='https://aws.amazon.com/' className={bootstrapStyling}><img className='footer-centered-element' src='https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg' height={imgHeight} /><h4 className='footer-centered-element'>AWS</h4></a>
                </div>
            </div>
        </div>
    )
}

export default Footer